import React from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const LOGO_URL = "https://res.cloudinary.com/dfg8nrgvf/image/upload/q_auto/f_auto/v1780693784/BOTG_Logo_o9fcqe.png";

export default function TermsOfService() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6">
      <div className="max-w-3xl mx-auto">
        <div className="flex justify-center mb-10 cursor-pointer" onClick={() => navigate('/')}>
          <img src={LOGO_URL} alt="BookOTG" className="h-14 object-contain" />
        </div>
        
        <div className="bg-white rounded-[2.5rem] shadow-sm border border-gray-100 p-8 sm:p-12">
          <h1 className="text-3xl font-black text-brand-dark tracking-tight mb-2">Terms of Service</h1>
          <p className="text-gray-400 font-bold uppercase text-[10px] tracking-widest mb-8">Effective Date: June 2026</p>

          <div className="prose prose-gray max-w-none text-gray-600 space-y-6 text-sm sm:text-base leading-relaxed">
            <p className="font-medium">
              These Terms of Service govern access to and use of the BookOTG platform operated by <strong>Based Byte Pte Ltd</strong>. By accessing or using BookOTG, you agree to these Terms.
            </p>

            <h2 className="text-xl font-black text-brand-dark mt-10 mb-4">Overview</h2>
            <p>
              BookOTG is an online marketplace connecting customers with independent self-employed barbers. BookOTG is not a salon, barber shop, employer, staffing agency, or provider of barber services. Services are provided directly by independent barbers.
            </p>

            <h2 className="text-xl font-black text-brand-dark mt-10 mb-4">Eligibility</h2>
            <p>
              Users must be at least 16 years old. By using BookOTG, you represent and warrant that you meet this requirement.
            </p>

            <h2 className="text-xl font-black text-brand-dark mt-10 mb-4">User & Barber Accounts</h2>
            <p>
              Users are responsible for maintaining account security and all activities under their account. Barbers represent that they are legally permitted to provide services, maintain required licenses, and provide services professionally.
            </p>

            <h2 className="text-xl font-black text-brand-dark mt-10 mb-4">Booking & Payments</h2>
            <p>
              Bookings are confirmed only when accepted by the barber. Payments may be made through supported in-app methods or directly to the barber in cash. BookOTG may collect platform fees or commissions from barbers.
            </p>

            <h2 className="text-xl font-black text-brand-dark mt-10 mb-4">Cancellations</h2>
            <p>
              Both customers and barbers may cancel bookings. Currently, BookOTG does not impose cancellation fees, but repeated abuse may result in account suspension.
            </p>

            <h2 className="text-xl font-black text-brand-dark mt-10 mb-4">Independent Contractor Relationship</h2>
            <p>
              Barbers are independent contractors. Nothing in these Terms creates employment, agency, or partnership. Barbers remain solely responsible for services, conduct, taxes, and compliance.
            </p>

            <h2 className="text-xl font-black text-brand-dark mt-10 mb-4">Disclaimers & Liability</h2>
            <p>
              BookOTG provides the platform "as is." We do not guarantee barber availability or service quality. To the maximum extent permitted by law, Based Byte Pte Ltd shall not be liable for indirect damages or disputes between users.
            </p>

            <h2 className="text-xl font-black text-brand-dark mt-10 mb-4">Governing Law</h2>
            <p>
              These Terms shall be governed by the laws of <strong>Singapore</strong> unless otherwise required by applicable consumer protection laws.
            </p>

            <div className="bg-brand-dark text-white p-8 rounded-3xl mt-12">
              <h3 className="font-black text-lg mb-4 uppercase tracking-widest text-brand-accent">Contact Information</h3>
              <p className="font-black text-lg mb-2">Based Byte Pte Ltd</p>
              <p className="text-white/60 text-sm">133 New Bridge Road #14-03</p>
              <p className="text-white/60 text-sm">Chinatown Point</p>
              <p className="text-white/60 text-sm">Singapore 059413</p>
              <p className="mt-4 font-black">Email: manager@bookotg.com</p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-100 text-center">
            <button
              onClick={() => navigate(-1)}
              className="text-brand-primary font-bold hover:underline flex items-center justify-center gap-2 mx-auto"
            >
              <SafeIcon name="ArrowLeft" />
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}